module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.06.b-c00a2ac448daaa451199523f134d7708.svg";